// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__556_G","main":"page_main__nw1Wk","logo":"page_logo__ikIZE","pulse":"page_pulse__XPtbN"};